import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Information from 'modules/Information';
import { renderLegalConsentField } from '../renderers';
const PrivacyAndHealthDataConsents = ()=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const privacyAndHealthDataConsents = consentsTemplate.filter((consent)=>consent.type === 'PrivacyAndHealthData');
    if (!privacyAndHealthDataConsents.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: privacyAndHealthDataConsents.map(renderLegalConsentField)
    });
};
export default PrivacyAndHealthDataConsents;
